<script setup>
import { ref, computed, onMounted } from 'vue';
import Modal from './FullModal.vue';
import Messenger from './Messenger.vue';
import { useStore } from 'vuex';
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import Avatar from './Avatar.vue';

const store = useStore();
const showMessenger = computed(() => store.state.showMessenger);
const messageView = ref(false);
const receiver = ref();

const props = defineProps({
    id: String,
    user_id: String,
    user_name: String,
    user_lastname: String,
    user_image: String
});

const close = () => {
    store.commit('closeMessenger');
    messageView.value = false;
}

const setMessageView = (user) => {
    messageView.value = true;
    receiver.value = user;
}

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('channel')) {
        store.commit('openMessenger', urlParams.get('channel'));
    }
})

</script>

<template>
    <Modal :show="showMessenger" @closes="close">
        <template #headers>
            <div class="tw-flex tw-items-center">
                <div v-if="messageView" @click="messageView = false" class="md:tw-hidden">
                    <button class="tw-pr-5 tw-text-gray-400 hover:tw-text-gray-800 tw-bg-transparent">
                        <ArrowLeftIcon class="tw-w-6" />
                    </button>
                </div>
                <div class="max-md:tw-hidden">
                    <h3 class="tw-text-base tw-font-semibold tw-leading-6 tw-text-gray-900 tw-mb-0">Messenger</h3>
                    <p class="tw-mt-1 tw-text-sm tw-text-gray-500 tw-mb-0">Alle Nachrichten auf einen Blick.</p>
                </div>

                <div class="md:tw-hidden">

                    <template v-if="messageView">
                        <div class="tw-flex tw-space-x-3 tw-items-center">
                            <Avatar class="tw-h-10 tw-w-10 text-md group-hover:tw-opacity-0"
                                :initials="receiver?.firstname.substring(0, 1) + receiver?.lastname?.substring(0, 1)"
                                :path="receiver?.avatar" />
                            <span>{{ receiver?.fullname }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <h3 class="tw-text-base tw-font-semibold tw-leading-6 tw-text-gray-900 tw-mb-0">Messenger</h3>
                        <p class="tw-mt-1 tw-text-sm tw-text-gray-500 tw-mb-0">Alle Nachrichten auf einen Blick.</p>
                    </template>

                </div>
            </div>
        </template>
        <Messenger @messageView="setMessageView" v-if="showMessenger" :id="props.id" :message_view="messageView"
            :user_id="props.user_id" :user_name="props.user_name" :user_lastname="props.user_lastname"
            :user_image="props.user_image" />
    </Modal>
</template>
